// extracted by mini-css-extract-plugin
export default {"header":"style_header__R3UyV","title":"style_title__XlK7O","deleteButton":"style_deleteButton__qLoX5"};